<!--<app-zendy-header *ngIf="isMobile"></app-zendy-header>-->

<div class="bg-gray-50">
  <!--<div class="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">-->
  <div>
    <div class="mt-6 grid gap-4 grid-cols-1 lg:grid-cols-2 ">

      <!-- LLAMADAS INTERNACIONALES -->
      <div class="relative dashboard-box">
        <div class="absolute inset-px rounded-[16px]"></div>
        <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">
          <!-- HEADER -->
          <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header">
            <h2 class="text-xl text-white font-semibold w-fit mb-0">{{ "COMPONENTS.HEADER.CALLS" | translate }}</h2>
            <h2 class="w-fit mb-0 svg-white">
              <img width="20" height="20" [src]="'../assets/icons/phone.svg'" />
            </h2>
          </div>

          <div class="@container relative  w-full grow max-lg:mx-auto max-lg:max-w-sm px-8">
            <div class="mt-6 mb-6 inset-x-0">
              <!-- CONTENT -->
              <p class="w-full flex-row mb-2 mt-4 mr-2 text-gray items-center gap-2">{{ 'COMPONENTS.HEADER.BALANCE' | translate }}</p>
              <div class="w-full flex justify-between items-center">
                <span class="text-light-red number text-center justify-center items-end">{{ balance | currency : currency : 'symbol' }}</span>

                <img [title]="'HOME.GOTOPROFILE' | translate" src="https://cdn.zendy.tel/images/Powered-by-T.png" />
              </div>
              <div class="w-full flex flex-cols-2 justify-between items-center my-4 gap-4">
                <app-button class="w-80 btn-white" hasIcon="hasIcon" (click)="openCountriesModal()">
                  <img width="24px" height="24px" class="svg-red" src="./assets/icons/rates-button.svg" />
                  {{ 'RECHARGES.RATES_BUTTON' | translate }}
                </app-button>

                <app-button class="w-80 btn-white" hasIcon="hasIcon" routerLink="/history">
                  <mat-icon class="text-light-red text-[24px] !size-[24px] ">list-alt</mat-icon>
                  {{ 'COMPONENTS.BLOCKS.SEE_HISTORY_CALLS' | translate }}
                </app-button>
              </div>

              <!-- FOOTER -->
              <div class="block-footer flex justify-center mt-8 mb-6 inset-x-0 bottom-0 w-full !font-medium">
                <app-button expand="full" hasIcon="hasIcon" routerLink="/recharges">
                  <mat-icon class="text-[24px] !size-[24px] align-bottom">add_circle_outline</mat-icon>
                  {{ 'RECHARGES.ADD_BTN' | translate }}
                </app-button>
              </div>

            </div>
          </div>

        </div>
        <div class="pointer-events-none absolute inset-px ring-1 shadow-sm ring-black/5 rounded-[16px]"></div>
      </div>

      <!-- OPERADORA MOVIL - DESACTIVADA (operadora móvil cerrada) -->
      <div class="relative dashboard-box lg:row-span-2 h-[550px] lg:h-auto lg:min-h-[720px]" *ngIf="false">
        <div class="absolute inset-px rounded-[16px]"></div>
        <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">
          <!-- HEADER -->
          <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header" *ngIf="userContracts.length > 0">
            <h2 class="text-xl text-white font-semibold w-fit mb-0">{{ "COMPONENTS.HEADER.MOBILE_OPERATOR" | translate }}</h2>
            <h2 class="w-fit mb-0">
              <img width="20" height="20" [src]="'./assets/icons/mobile.svg'" />
            </h2>
          </div>


          <div class="@container relative w-full grow max-lg:mx-auto max-lg:max-w-sm px-8 no-info mobile-operator" *ngIf="userContracts.length == 0 || showSpinnerMobile">

            <div class="mt-6 mb-6 inset-x-0 bg-red">
              <!-- CONTENT -->
              <p class="w-full flex-row mb-2 mt-4 mr-2 font-bold text-white text-center items-center gap-2">{{ 'COMPONENTS.BLOCKS.MOBILE_OPERATOR_TITLE' | translate }}</p>
              <p class="w-full flex-row mb-2 mt-4 mr-2 text-white text-center items-center gap-2">{{ 'COMPONENTS.BLOCKS.MOBILE_OPERATOR_SUBTITLE' | translate }}</p>
              <div class="w-full flex flex-cols-2 align-center justify-center items-center my-4 gap-4" *ngIf="userContracts.length == 0">
                <app-button hasIcon="hasIcon" (click)="window.open(mobileUrl, '_blank')">
                  <mat-icon class="text-[24px] !size-[24px] align-bottom">add_circle_outline</mat-icon>
                  <span class=" !font-medium">{{ 'COMPONENTS.BLOCKS.MOBILE_BTN' | translate }}</span>
                </app-button>
              </div>

              <div class="align-middle flex">
                <div *ngIf="showSpinnerMobile" class="w-[100%]">
                  <div class="w-[100%] min-h-[260px] justify-items-center content-center"><mat-spinner diameter="50" strokeWidth="3"></mat-spinner></div>
                </div>
              </div>

              <!-- FOOTER -->
              <div class="block-footer flex justify-center mt-8 mb-6 inset-x-0 bottom-0 w-full !font-medium">
              </div>

            </div>
          </div>

          <div class="@container relative w-full grow max-lg:mx-auto max-lg:max-w-sm px-8" *ngIf="userContracts.length > 0">
            <div class="mt-6 mb-0 inset-x-0 h-[86%]">

              <igx-carousel #carouselmobile *ngIf="userContracts.length > 0" class="mobile-contracts{{userContracts.length == 1 ? '-once' : ''}}">
                <igx-slide *ngFor="let contract of userContracts" class="">

                  <mat-card class="contract-card !bg-transparent !shadow-none">
                    <mat-card-header class="mb-2 flex items-top justify-between !p-0">
                      <div class="relative left-0">
                        <p class="w-full text-gray items-center gap-2">{{ 'Tu tarifa' | translate }}</p>
                        <h3 class="text-light-red">{{ contract.title }}</h3>
                        <h2 class="!text-gray text-center">{{ contract.number }}</h2>
                        <app-button (click)="show_pin_puk(contract)" class="mt-4 justify-self-center"><span class="!font-medium">{{ 'PIN/PUK' | translate }}</span></app-button>
                      </div>

                      <div class="esim-my-card-image-container relative ml-4">
                        <img src="https://cdn.zendy.tel/images/mobiles.png" alt="SIM Card" class="esim-my-card-image" />
                      </div>
                    </mat-card-header>

                    <mat-card-content class="my-8">

                      <!-- Datos -->
                      <div class="progress-section" *ngIf="contract.consumption.data.total > 0">
                        <div class="label-container">
                          <strong>{{ 'ESIM.DATA' | translate }}:</strong>
                          <p class="item-value right-align">
                            {{ 'ESIM.USED' | translate }}: {{ contract.consumption.data.used }}GB
                            {{ 'ESIM.OF' | translate }} <span class="font-semibold">{{ contract.consumption.data.total }}GB</span>
</p>
                        </div>
                        <mat-progress-bar mode="determinate"
                                          [value]="calculatePercentage(contract.consumption.data.total, contract.consumption.data.used)"
                                          class="progress-bar"></mat-progress-bar>
                      </div>

                      <!-- Voz -->
                      <div class="progress-section" *ngIf="contract.consumption.minutes.national.total > 0">
                        <div class="label-container">
                          <strong>{{ 'COMPONENTS.BLOCKS.VOICE_NATIONAL' | translate }}:</strong>
                          <p class="item-value right-align">
                            {{ 'ESIM.USED' | translate }}: {{ contract.consumption.minutes.national.used }}
                            min {{ 'ESIM.OF' | translate }} <span class="font-semibold"><mat-icon class="text-[24px] !size-[24px] align-bottom text-light-red">all_inclusive</mat-icon> min</span>
                          </p>
                        </div>
                        <mat-progress-bar mode="determinate"
                                          [value]="calculatePercentage(contract.consumption.minutes.national.total, contract.consumption.minutes.national.used)"
                                          class="progress-bar"></mat-progress-bar>
                      </div>

                      <div class="progress-section" *ngIf="contract.consumption.minutes.international.total > 0">
                        <div class="label-container">
                          <strong>{{ 'COMPONENTS.BLOCKS.VOICE_INTERNATIONAL' | translate }}:</strong>
                          <p class="item-value right-align">
                            {{ 'ESIM.USED' | translate }}: {{ contract.consumption.minutes.international.used }}
                            min {{ 'ESIM.OF' | translate }} <span class="font-semibold">{{ contract.consumption.minutes.international.total }} min</span>
</p>
                        </div>
                        <mat-progress-bar mode="determinate"
                                          [value]="calculatePercentage(contract.consumption.minutes.international.total, contract.consumption.minutes.international.used)"
                                          class="progress-bar"></mat-progress-bar>
                      </div>

                      <!-- SMS -->
                      <div class="progress-section" *ngIf="contract.consumption.sms.total > 0 || contract.consumption.sms.used > 0">
                        <div class="label-container">
                          <strong>SMS:</strong>
                          <p class="item-value right-align">
                            {{ 'ESIM.USED' | translate }}: {{ contract.consumption.sms.used }}
                            {{ 'ESIM.OF' | translate }} {{ contract.consumption.sms.total }}
                          </p>
                        </div>
                        <mat-progress-bar mode="determinate"
                                          [value]="calculatePercentage(contract.consumption.sms.total, contract.consumption.sms.used)"
                                          class="progress-bar"></mat-progress-bar>
                      </div>
                    </mat-card-content>

                    <div class="columns-2 gap-4 *:mb-4 *:h-[50px] *:font-[500]">
                      <div class="bg-white rounded-lg py-1 px-4 flex items-center"><img src="https://cdn.zendy.tel/images/bullet.png" class="mr-3 !h-[16px]" /><span class="font-semibold text-2xl text-light-red mr-2">{{ contract.consumption.data.total }}GB</span>  {{ 'COMPONENTS.BLOCKS.MOBILE_CUMULATIVE' | translate }}</div>
                      <div class="bg-white rounded-lg py-1 px-4 flex items-center"><img src="https://cdn.zendy.tel/images/bullet.png" class="mr-3 !h-[16px]" />{{ 'COMPONENTS.BLOCKS.MOBILE_NO_LIMIT_CALLS' | translate }}</div>
                      <div class="bg-white rounded-lg py-1 px-4 flex items-center"><img src="https://cdn.zendy.tel/images/bullet.png" class="mr-3 !h-[16px]" />{{ 'COMPONENTS.BLOCKS.MOBILE_NO_PERMANENCY' | translate }}</div>
                      <div class="bg-white rounded-lg py-1 px-4 flex items-center"><img src="https://cdn.zendy.tel/images/bullet.png" class="mr-3 !h-[16px]" /><span class="font-semibold text-2xl text-light-red">{{ contract.amount | currency : currency : 'symbol' }}</span><span class="mb-3 items-baseline">{{ "COMPONENTS.BLOCKS.MOBILE_MONTH" | translate }}</span></div>
                    </div>
                    <div class="gap-4 *:mb-4 *:h-[50px] *:font-[500]" *ngIf="contract.allow_free_transfer">
                      <div class="rounded-lg bg-white py-1 px-4 flex items-center col-span-2"><img src="https://cdn.zendy.tel/images/bullet.png" class="mr-3 !h-[16px]" />{{ "COMPONENTS.BLOCKS.MOBILE_FREE_TRANSFER" | translate }}</div>
                    </div>

                  </mat-card>

                </igx-slide>
              </igx-carousel>

              <div class="block-footer flex justify-center mb-0 inset-x-0 bottom-0 w-full !font-medium">
                <div class="w-full flex flex-cols-2 align-center justify-center items-center my-0 gap-4">
                  <app-button hasIcon="hasIcon" (click)="window.open(mobileUrl, '_blank')">
                    <mat-icon class="text-[24px] !size-[24px] align-bottom">add_circle_outline</mat-icon>
                    <span class=" !font-medium">{{ 'COMPONENTS.BLOCKS.MOBILE_BTN' | translate }}</span>
                  </app-button>
                </div>
              </div>

            </div>

          </div>

          <div class="pointer-events-none absolute inset-px ring-1 shadow-sm ring-black/5 rounded-[16px]"></div>
        </div>
      </div>

      <!-- ESIMS -->
      <div class="relative dashboard-box">
        <div class="absolute inset-px rounded-[16px]"></div>
        <div class="relative flex flex-col min-h-[350px] overflow-hidden rounded-[16px]">
          <!-- HEADER -->
          <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header">
            <h2 class="text-xl text-white font-semibold w-fit mb-0">{{ "COMPONENTS.BLOCKS.ACTIVE_ESIMS_TITLE" | translate }}</h2>
            <h2 class="w-fit mb-0 svg-white">
              <img width="20" height="20" [src]="'../assets/icons/sim_card.svg'" />
            </h2>
          </div>

          <div class="@container relative w-full grow min-h-[350px] px-2 lg:px-8">
            <div class="mt-6 mb-6 inset-x-0">
              <!-- CONTENT -->
              <div class="align-middle flex">
                <div *ngIf="esimLoader" class="w-full flex items-center justify-center min-h-[260px]">
                  <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
                </div>

                <div *ngIf="!esimLoader" class="w-full text-center">
                  <div *ngIf="userEsims.length == 0" class="w-full text-center py-4">
                    <img class="mx-auto mb-4" width="60" height="60" [src]="'https://cdn.zendy.tel/images/no_esim.png'" />
                    <h3 class="mb-2">{{ "COMPONENTS.BLOCKS.NO_ESIM" | translate }}</h3>
                    <p class="mb-0">{{ "COMPONENTS.BLOCKS.NO_ESIM_SUBTITLE" | translate }}</p>
                  </div>
                  <igx-carousel #carousel *ngIf="userEsims.length > 0" class="travelsims{{userContracts.length == 1 ? '-once' : ''}}">
                    >
                    <igx-slide *ngFor="let esim of userEsims" class="">

                      <mat-card class="esim-card" appearance="outlined">

                        <mat-card-header class="mb-2 flex justify-center items-top">
                          <!-- 🔹 Iconos del tipo de plan -->
                          <div class="absolute left-0 ml-4 p-2 flex" style="height:fit-content;"
                              *ngIf="esim?.pkg_details?.operator_info?.plan_type as planType">
                            <div *ngFor="let item of planType.split('-')">
                              <img width="16"
                                  [src]="'./assets/icons/' + item + '_ico.svg'"
                                  [title]="item"
                                  class="mx-1" />
                            </div>
                          </div>

                          <!-- 🔹 Bandera -->
                          <div class="rounded-full bg-white absolute right-0 mr-4 p-2"
                              style="height:fit-content;"
                              *ngIf="esim?.pkg_details?.country_url">
                            <span class="flag large block content-center">
                              <img [src]="esim.pkg_details.country_url" alt="flag" />
                            </span>
                          </div>

                          <!-- 🔹 Imagen de la SIM -->
                          <div class="esim-my-card-image-container relative ml-4">
                            <img src="https://cdn.zendy.tel/images/Esim/EsimCard@2x.png"
                                alt="SIM Card"
                                class="esim-my-card-image" />
                            <span class="esim-my-country-label">{{ esim?.country }}</span>
                          </div>
                        </mat-card-header>

                        <mat-card-content>
                          <mat-card-subtitle class="font-bold text-center">{{ esim.details.iccid }}</mat-card-subtitle>
                          <mat-card-title class="font-bold text-center">{{ esim.country | titlecase }}</mat-card-title>
                          <mat-card-subtitle class="text-center mb-3"><span class="font-bold">{{ "ESIM.PURCHASE_DETAILS.VALIDITY" | translate }}:</span> {{ esim.validity }}</mat-card-subtitle>
                        </mat-card-content>
                        <mat-card-actions class="buybutton mt-auto bottom-0 left-0 ">
                          <div>
                            <button mat-button class="view-btn shadow-xl" (click)="openEsimDetailsDialog(esim)">{{ 'ESIM.BTN_DETAILS' | translate }}</button>
                          </div>
                        </mat-card-actions>
                      </mat-card>

                    </igx-slide>
                  </igx-carousel>

                </div>
              </div>

              <!-- Warning para eSIMs inactivas -->
              <div *ngIf="inactiveEsimsCount > 0" class="inactive-warning-box mt-6 mb-4">
                <mat-icon class="warning-icon">warning</mat-icon>
                <div class="warning-content">
                  <p class="warning-text">
                    {{ 'COMPONENTS.BLOCKS.INACTIVE_ESIM_WARNING' | translate: { count: inactiveEsimsCount } }}
                    <a [routerLink]="['/my-esims']" [queryParams]="{tab: 1}" class="warning-link">
                      {{ 'COMPONENTS.BLOCKS.VIEW_INACTIVE_ESIMS' | translate }}
                    </a>
                  </p>
                </div>
              </div>

              <!-- FOOTER -->
              <div class="block-footer flex justify-center mx-0 inset-x-0 bottom-0 w-full !font-medium">
                <div class="w-full flex flex-col lg:flex-row lg:flex-cols-2 justify-{{btn_position}} items-center my-0 gap-4">
                  <div *ngIf="userEsims.length > 0"><span class="text-light-red number text-3xl">{{ userEsims.length }}</span> {{ 'COMPONENTS.BLOCKS.ESIM_COUNTER' | translate }}</div>

                  <app-button hasIcon="hasIcon" (click)="goToEsimSection()">
                    <mat-icon class="text-white text-[24px] !size-[24px] ">add_circle_outline</mat-icon>
                    <span class="!font-medium">{{ 'ESIM.BUY_ESIM' | translate }}</span>
                  </app-button>
                </div>
              </div>

            </div>
          </div>

        </div>
        <div class="pointer-events-none absolute inset-px ring-1 shadow-sm ring-black/5 rounded-[16px]"></div>
      </div>

      <!-- PRESTAMOS -->
      <div class="relative dashboard-box lg:col-span-2">
        <div class="absolute inset-px rounded-[16px]"></div>
        <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">
          <!-- HEADER -->
          <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header hidden">
            <h2 class="text-xl text-white font-semibold w-fit mb-0">{{ "COMPONENTS.TABS.TAB6" | translate }}</h2>
            <h2 class="w-fit mb-0">
              <img width="28" height="28" [src]="'./assets/icons/credits.svg'" class="svg-red" />
            </h2>
          </div>

          <div class="@container relative w-full grow no-info">
            <div class="inset-x-0 bg-red">
              <!-- CONTENT -->
              <div class="flex">
                <div class="w-[25%] h-[160px]" style="background: var(--color-light-red) url('https://cdn.zendy.tel/images/Header-Mobile-5@3x.jpg'); background-size: cover; background-position: center; "></div>

                <div class="w-full px-6">
                  <h2 class="w-fit !mt-8">
                    <img width="34" height="34" [src]="'./assets/icons/credits.svg'" class="svg-white" />
                  </h2>
                  <h2 class="text-xl text-white font-semibold w-fit !my-2">{{ "COMPONENTS.TABS.TAB6" | translate }}</h2>
                  <div class="flex justify-between between text-white gap-4">
                    <div class="w-[80%]">{{ "COMPONENTS.BLOCKS.CREDIT_TEXT" | translate }}</div>
                    <mat-icon class="!text-[30px] !size-[30px] cursor-pointer" hasIcon="hasIcon" *ngIf="!creditsUrl.includes('http')" [routerLink]="creditsUrl">play_circle_outline</mat-icon>
                    <mat-icon class="!text-[30px] !size-[30px] cursor-pointer" hasIcon="hasIcon" *ngIf="creditsUrl.includes('http')"  (click)="window.open(creditsUrl, '_blank')">play_circle_outline</mat-icon>
                    <!--<mat-icon class="border-2 rounded-full w-fit p-2" hasIcon="hasIcon" (click)="window.open(creditsUrl, '_blank')">arrow_forward</mat-icon>-->
                  </div>
                </div>
              </div>

              <!-- FOOTER -->
              <div class="block-footer flex justify-center mt-8 mb-6 inset-x-0 bottom-0 w-full !font-medium hidden">
              </div>

            </div>
          </div>

        </div>
        <div class="pointer-events-none absolute inset-px ring-1 shadow-sm ring-black/5 rounded-[16px]"></div>
      </div>

<!--      &lt;!&ndash; ENVÍO DE DINERO &ndash;&gt;-->
<!--      <div class="relative dashboard-box">-->
<!--        <div class="absolute inset-px rounded-[16px]"></div>-->
<!--        <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">-->
<!--          &lt;!&ndash; HEADER &ndash;&gt;-->
<!--          <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header hidden">-->
<!--            <h2 class="text-xl text-white font-semibold w-fit mb-0">{{ "COMPONENTS.BLOCKS.SENDMONEY_TITLE" | translate }}</h2>-->
<!--            <h2 class="w-fit mb-0">-->
<!--              <img width="28" height="28" [src]="'./assets/icons/credits.svg'" class="svg-red" />-->
<!--            </h2>-->
<!--          </div>-->

<!--          <div class="@container relative w-full grow px-8 no-info">-->
<!--            <div class="mt-6 mb-6 inset-x-0 bg-red">-->
<!--              &lt;!&ndash; CONTENT &ndash;&gt;-->
<!--              <h2 class="w-fit !mt-8">-->
<!--                <img width="34" height="34" [src]="'./assets/icons/credits.svg'" class="svg-white" />-->
<!--              </h2>-->
<!--              <h2 class="text-xl text-white font-semibold w-fit !my-2">{{ "COMPONENTS.BLOCKS.SENDMONEY_TITLE" | translate }}</h2>-->
<!--              <div class="flex justify-between between text-white gap-4">-->
<!--                <div class="w-[80%]">{{ "COMPONENTS.BLOCKS.SENDMONEY_TEXT" | translate }}</div>-->
<!--                <mat-icon class="!text-[30px] !size-[30px] cursor-pointer" hasIcon="hasIcon" type="button" (click)="goToTransfers()" >play_circle_outline</mat-icon>-->
<!--              </div>-->

<!--              &lt;!&ndash; FOOTER &ndash;&gt;-->
<!--              <div class="block-footer flex justify-center mt-8 mb-6 inset-x-0 bottom-0 w-full !font-medium hidden">-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
<!--        <div class="pointer-events-none absolute inset-px ring-1 shadow-sm ring-black/5 rounded-[16px]"></div>-->
<!--      </div>-->

      <!-- LISTADO DE ENVÍOS DE DINERO -->
<!--      <div class="relative dashboard-box lg:col-span-2" *ngIf="transactions.length > 0 || showSpinnerTransfers">-->
<!--        <div class="absolute inset-px rounded-[16px]"></div>-->
<!--        <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">-->
<!--          &lt;!&ndash; HEADER &ndash;&gt;-->
<!--          <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header">-->
<!--            <h2 class="text-xl text-white font-semibold w-fit mb-0">{{ "COMPONENTS.BLOCKS.SENDMONEY_TITLE" | translate }}</h2>-->
<!--            <h2 class="w-fit mb-0 svg-white">-->
<!--              <img width="20" height="20" [src]="'../assets/icons/credits.svg'" />-->
<!--            </h2>-->
<!--          </div>-->
<!--          <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">-->
<!--            <div class="flex mt-6 mb-6 inset-x-0 bottom-0">-->

<!--              <div class="align-middle flex w-full" *ngIf="showSpinnerTransfers">-->
<!--                <div class="w-[100%]">-->
<!--                  <div class="w-[100%] min-h-[260px] justify-items-center content-center"><mat-spinner diameter="50" strokeWidth="3"></mat-spinner></div>-->
<!--                </div>-->
<!--              </div>-->

<!--              &lt;!&ndash; NEW GENERIC LIST COMPONENT &ndash;&gt;-->
<!--              <app-generic-list class="w-full flex-col" *ngIf="transactions.length > 0 && !showSpinnerTransfers"-->
<!--                                filterKeyPrefix="transactions"-->
<!--                                [items]="transactions"-->
<!--                                (itemClick)="onItemClick($event)"-->
<!--                                [filterFields]="filterTransactionFields"-->
<!--                                [showFilters]="true"-->
<!--                                [isFiltersCollapsed]="true"-->
<!--                                [allowDownload]="false"-->
<!--                                (filtersChanged)="onFiltersChanged($event)"-->
<!--                                (pageChanged)="onPageChanged($event)"-->
<!--                                (filteredCount)="filteredCounts.transactions = $event"-->
<!--                                (pageSize)="10">-->
<!--                &lt;!&ndash;-->
<!--                <ng-template #headerTemplate>-->
<!--                    <h2>Facturas</h2>-->
<!--                </ng-template>-->
<!--                &ndash;&gt;-->
<!--                <ng-template #itemTemplate let-item role="list" *ngIf="transactions.length > 0 && !showSpinnerTransfers" class="w-full max-h-[300px] overflow-y-auto">-->
<!--                  <div class="*:mb-2 *:py-2 *:font-[400] items-center flex justify-between gap-x-6 w-full">-->
<!--                    <div class="!font-bold"><mat-icon class="cursor-pointer !text-[25px] !size-[25px] text-red-600 material-icons-outlined align-bottom" (click)="viewTransferDetails(item)">info</mat-icon></div>-->
<!--                    <div class="w-2/5 !font-bold align-middle cursor-pointer" *ngIf="!isMobile" (click)="viewTransferDetails(item)">{{ getFullName(item.beneficiary_fields) }}</div>-->
<!--                    <div class="w-1/5 !font-bold flex items-center">{{item.country}}</div>-->
<!--                    <div class="!font-bold flex items-center" *ngIf="isMobile"><div title="{{ 'TRANSFERS.STATUS.'+item.transaction.status | translate }}" class="mr-2 size-[10px] rounded-full {{ item.transaction.status == 'DELIVERED' ? 'bg-green-700 border-green-700' : ( item.transaction.status == 'CANCELLED' || item.transaction.status == 'ERROR' ? 'bg-light-red border-light-red' : 'text-blue-300 border-blue-300') }}"></div></div>-->
<!--                    <div class="{{ isMobile ? '' : 'w-1/5' }} text-end">{{ item.transaction.created | date:'dd/MM/yyyy' }}</div>-->
<!--                    <div class="text-lg {{ isMobile ? '' : 'w-1/5' }} !font-[600] text-end">{{ item.transaction.payment_amount | currency : currency : 'symbol' }}</div>-->
<!--                    <div class="w-1/5" *ngIf="!isMobile"><span class="rounded-lg border font-bold text-xs py-1 px-6 {{ item.transaction.status == 'DELIVERED' ? 'bg-green-700 border-green-700 text-white' : ( item.transaction.status == 'CANCELLED' || item.transaction.status == 'ERROR' ? 'bg-light-red border-light-red text-white' : 'text-blue-300 border-blue-300') }}">{{ 'TRANSFERS.STATUS.'+item.transaction.status | translate }}</span></div>-->
<!--                  </div>-->
<!--                </ng-template>-->

<!--                <div *ngIf="filteredCounts.transactions == 0 && !showSpinnerTransfers" class="w-full content-center h-[200px]">-->
<!--                  <div class="!font-medium text-center">-->
<!--                    <div class="w-100 text-center text-gray-500"><mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">send</mat-icon></div>-->
<!--                    {{ "COMPONENTS.BLOCKS.NO_TRANSFERS" | translate }}-->
<!--                  </div>-->
<!--                </div>-->

<!--                &lt;!&ndash;-->
<!--                <ng-template #actionsTemplate let-transaction *ngIf="transactions.length > 0 && !showSpinnerTransfers">-->
<!--                   <button (click)="editItemList(item); $event.stopPropagation()">✏️</button>-->
<!--                  <button (click)="deleteItemList(item); $event.stopPropagation()">🗑️</button>-->
<!--                </ng-template>-->
<!--                &ndash;&gt;-->

<!--                <ng-template #footerTemplate>-->
<!--                  <footer>-->
<!--                    {{ "COMMON.TOTAL" | translate }}: {{ filteredCounts.transactions }} {{ "CONTACTS.DETAILS.TRANSFERS_TITLE" | translate }}</footer>-->
<!--                </ng-template>-->
<!--              </app-generic-list>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>-->
<!--      </div>-->

      <!-- FACTURAS -->
      <div class="relative dashboard-box lg:col-span-2 ">
        <div class="absolute inset-px rounded-[16px]"></div>
        <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">
          <!-- HEADER -->
          <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header">
            <h2 class="text-xl text-white font-semibold w-fit mb-0">{{ "COMPONENTS.BLOCKS.RECEIPTS_TITLE" | translate }}</h2>

          </div>
          <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">
            <div class="flex mt-6 mb-6 inset-x-0 bottom-0">

              <div class="align-middle flex w-full" *ngIf="showSpinnerBills">
                <div class="w-[100%]">
                  <div class="w-[100%] min-h-[260px] justify-items-center content-center"><mat-spinner diameter="50" strokeWidth="3"></mat-spinner></div>
                </div>
              </div>


              <!-- NEW GENERIC LIST COMPONENT -->
              <app-generic-list class="w-full flex-col" *ngIf="userBills.length > 0 && !showSpinnerBills"
                                filterKeyPrefix="bills"
                                [items]="userBills"
                                (itemClick)="onItemClick($event)"
                                [filterFields]="filterBillsFields"
                                [showFilters]="true"
                                [isFiltersCollapsed]="true"
                                [allowDownload]="true"
                                (filtersChanged)="onFiltersChanged($event)"
                                (pageChanged)="onPageChanged($event)"
                                (filteredCount)="filteredCounts.userBills = $event">
                <!--
                <ng-template #headerTemplate>
                    <h2>Facturas</h2>
                </ng-template>
                -->

                <ng-template #itemTemplate let-item  role="list" *ngIf="userBills.length > 0 && !showSpinnerBills" class="w-full max-h-[300px] overflow-y-auto">
                  <div  class="*:mb-2 *:py-2 *:font-[400] items-center flex justify-between gap-x-6 w-full">
                    <div *ngIf="!isMobile" class="w-fit" title="{{ ( item.type == 'MOBILE' ? 'COMPONENTS.HEADER.MOBILE_OPERATOR' : ( item.type == 'ESIM' ? 'COMPONENTS.TABS.TAB5' : 'COMPONENTS.HEADER.CALLS' ) ) | translate }}">
                      <img *ngIf="item.type == 'CALLS'" width="35" height="35" class="svg-red-header" [src]="'../assets/icons/phone.svg'" />
                      <img *ngIf="item.type == 'ESIM'" width="35" height="35" class="svg-red-header" [src]="'../assets/icons/sim_card.svg'" />
                      <img *ngIf="item.type == 'MOBILE'" width="35" height="35" class="svg-red" [src]="'./assets/icons/mobile.svg'" />
                    </div>

                    <div class="w-3/5 !font-bold" *ngIf="!isMobile">{{ item.factura }}</div>
                    <div class="!font-bold flex items-center" *ngIf="isMobile"><div title="{{ item.situacion == 0 ? 'BILLS.PENDING' : 'BILLS.PAID' | translate }}" class="mr-2 size-[10px] rounded-full {{ item.situacion == 0 ? 'bg-light-red border-light-red' : 'bg-green-700 border-green-700' }}"></div><span (click)="downloadBill( item.type, item.id, item.factura )">{{ item.factura }}</span></div>
                    <div class="{{ isMobile ? '' : 'w-1/5' }} text-end">{{ item.fecha | date:'dd/MM/yyyy' }}</div>
                    <div class="text-lg {{ isMobile ? '' : 'w-1/5' }} !font-[600] text-end">{{ item.total | currency : currency : 'symbol' }}</div>
                    <div class="!m-0 !p-0" *ngIf="!isMobile"><img src="./assets/icons/download_bill.svg" (click)="downloadBill( item.type, item.id, item.factura )" target="_new" class="cursor-pointer size-[40px]" /></div>
                    <div class="w-1/5" *ngIf="!isMobile"><span class="rounded-lg border font-bold text-xs py-1 px-6 {{ item.situacion == 0 ? 'text-light-red border-light-red' : 'text-green-700 border-green-700' }}">{{ item.situacion == 0 ? 'BILLS.PENDING' : 'BILLS.PAID' | translate }}</span></div>
                  </div>
                </ng-template>

                <!--
                <ng-template #actionsTemplate let-item>
                  <button (click)="editItemList(item); $event.stopPropagation()">✏️</button>
                  <button (click)="deleteItemList(item); $event.stopPropagation()">🗑️</button>
                </ng-template>
                -->

                <div *ngIf="filteredCounts.userBills == 0 && !showSpinnerBills" class="w-full content-center h-[200px]">
                  <div class="!font-medium text-center">
                    <div class="w-100 text-center text-gray-500"><mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">receipt_long</mat-icon></div>
                    {{ "COMPONENTS.BLOCKS.NO_INVOICES" | translate }}
                  </div>
                </div>

                <ng-template #footerTemplate>
                  <footer>{{ "COMMON.TOTAL" | translate }}: {{ filteredCounts.userBills }} {{ "CONTACTS.DETAILS.TRANSFERS_TITLE" | translate }}</footer>
                </ng-template>
              </app-generic-list>

            </div>
          </div>
        </div>
        <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
      </div>

    </div>
  </div>
</div>

<div class="loading-mask" *ngIf="showSpinner">
  <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
</div>
